import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  buzonesList:[],
  currentOrden: JSON.parse(localStorage.getItem("currentOrden")) || ''
};

export const mutations = {
  GET_BUZONES({ context }, buzones) {
    let buzones_array = [];
    Object.entries(buzones).forEach(([key, val]) => buzones_array.push(val));
    return (state.buzonesList = buzones_array);
  },
  SHOW_BUZON ({ context }, buzon) {
    state.currentOrden = Object.assign({}, buzon);
    localStorage.setItem("currentOrden", JSON.stringify(state.currentOrden));
  }
};

export const actions = {

  GET_BUZONES({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // console.log(response.data);
          commit("GET_BUZONES", response.data.data.buzones);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_INITIAL_BUZON({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SHOW_PROMOCION", response.data.data.promocion);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SHOW_BUZON({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data.laboral);
          commit("SET_LOADING", false);
          commit("SHOW_BUZON", response.data.data.buzon);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

};

export const getters = {
  buzonesList: state => state.buzonesList,
  // currentOrden: state => state.currentOrden
};
